import type { Attachment, State } from './types'
import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@reduxjs/toolkit'

const initialState: State = {
  isOpen: false
}

const previewerSlice = createSlice({
  name: 'previewer',
  initialState,

  reducers: {
    open(state, action: PayloadAction<Attachment>) {
      state.attachment = action.payload
      state.isOpen = true
    },

    close(state) {
      state.attachment = undefined
      state.isOpen = false
    }
  }
})

export const { open, close } = previewerSlice.actions

export const previewerReducer = previewerSlice.reducer
